import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';
import { breakpoints } from './foundation/breakpoints';
import { colors } from './foundation/colors';
import { fontSizes } from './foundation/fontSizes';
import borders from './foundation/semanticTokens/borders';
import radii from './foundation/semanticTokens/radii';
import shadows from './foundation/semanticTokens/shadows';
import space from './foundation/semanticTokens/space';
import { form } from './components/form';
import { input } from './components/input';
import { button } from './components/button';
import { text } from './components/text';
import { formLabel } from './components/formLabel';
import { heading } from './components/heading';
import { card } from './components/card';
import { icon } from './components/icon';
import { select } from './components/select';
import { tabsTheme } from './components/tabs';
import { menuTheme } from './components/menu';
import { switchTheme } from './components/switch';
import { radio } from './components/radio';
import { checkboxTheme } from './components/checkbox';
import { numberInputTheme } from './components/numberInput';
import { Alert } from './components/alert';
import { avatar } from './components/avatar';

export const theme = (brand?: any) =>
  extendTheme(
    withDefaultColorScheme({
      colorScheme: 'neutral',
      components: ['Menu'],
    }),
    withDefaultColorScheme({
      colorScheme: 'tableGray',
      components: ['Table'],
    }),
    withDefaultColorScheme({
      colorScheme: 'brand',
      components: ['Tabs', 'Switch'],
    }),

    withDefaultColorScheme({
      colorScheme: 'blue',
      components: ['Checkbox'],
    }),

    {
      breakpoints,
      colors: colors(brand),
      fontSizes,

      components: {
        Form: form,
        Input: input,
        Select: select,
        NumberInput: numberInputTheme,
        Button: button,
        Card: card,
        Text: text,
        FormLabel: formLabel,
        Heading: heading,
        Icon: icon,
        Tabs: tabsTheme,
        Menu: menuTheme,
        Switch: switchTheme,
        Radio: radio,
        Checkbox: checkboxTheme,
        Alert,
        Avatar: avatar,
      },
      semanticTokens: {
        space,
        sizes: space,
        radii,
        borders,
        shadows,
      },
      config: {
        cssVarPrefix: 'qgx-theme',
        initialColorMode: 'dark',
        useSystemColorMode: false,
      },

      styles: {
        global: () => ({
          body: {
            bg: 'neutral.200',
          },
          table: {
            bg: 'tableGray.50',
            color: 'text.table',
            td: {
              color: 'text.table !important',
              p: {
                color: 'text.table',
              },
              Text: {
                color: 'text.table',
              },
            },
          },
          Thead: {
            bg: 'neutral.500',
            color: 'text.table',
            th: {
              color: 'white !important',
            },
          },
          '.chakra-modal__content-container': {
            '@media (max-width: 1024px)': {
              paddingLeft: '24px',
              paddingRight: '24px'
            }
          },
          '.chakra-modal__header': {
            borderBottom: '2px solid',
            paddingLeft: '0!important',
            paddingRight: '0!important',
            paddingBottom: '8px!important',
            marginLeft: '24px',
            marginRight: '24px',
            marginBottom: '16px',
            fontSize: '18px!important'
          }
        }),
      },
    },
  );
